import React, { useEffect, useState } from 'react';
import { ShieldCheck, ExternalLink, RefreshCw } from 'lucide-react';
import api from '../lib/auth';

export default function OfficerMasterLicencesPage() {
  const [loading, setLoading] = useState(true);
  const [licences, setLicences] = useState([]);

  const loadLicences = async () => {
    try {
      setLoading(true);
      const res = await api.get('/personnel-compliance/master-licences/officer-dashboard');
      setLicences(res.data?.master_licences || []);
    } catch (err) {
      console.error('Failed loading master licences', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLicences();
  }, []);

  return (
    <div className="min-h-screen bg-[#09090b] text-white p-4 md:p-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
          <div>
            <h1 className="text-3xl font-bold flex items-center gap-3">
              <ShieldCheck className="w-8 h-8 text-emerald-400" />
              Company Master Licence
            </h1>
            <p className="text-zinc-400 mt-2">
              Current company security master licence documents available for compliance verification.
            </p>
          </div>

          <button onClick={loadLicences} className="border border-zinc-700 hover:border-emerald-500 px-4 py-2 rounded-xl flex items-center gap-2">
            <RefreshCw className="w-4 h-4" />
            Refresh
          </button>
        </div>

        {loading ? (
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 text-zinc-400">
            Loading master licences...
          </div>
        ) : licences.length === 0 ? (
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center">
            <p className="text-zinc-400">No master licences uploaded.</p>
          </div>
        ) : (
          <div className="grid gap-4">
            {licences.map((licence) => (
              <div key={licence.id || licence._id} className="bg-zinc-900 border border-emerald-500/20 rounded-2xl p-5">
                <div className="grid md:grid-cols-2 gap-5">
                  <div>
                    <p className="text-zinc-500 text-sm mb-1">Company Name</p>
                    <p className="text-lg font-semibold">{licence.company_name || 'N/A'}</p>
                  </div>

                  <div>
                    <p className="text-zinc-500 text-sm mb-1">Master Licence Number</p>
                    <p className="text-lg font-semibold">{licence.master_licence_number || 'N/A'}</p>
                  </div>

                  <div>
                    <p className="text-zinc-500 text-sm mb-1">State of Issue</p>
                    <p className="text-lg">{licence.state_of_issue || 'N/A'}</p>
                  </div>

                  <div>
                    <p className="text-zinc-500 text-sm mb-1">Expiry Date</p>
                    <p className="text-lg">
                      {licence.expiry_date ? new Date(licence.expiry_date).toLocaleDateString('en-AU') : 'N/A'}
                    </p>
                  </div>
                </div>

                {licence.document_url && (
                  <div className="mt-6">
                    <a href={licence.document_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 transition px-5 py-3 rounded-xl font-semibold">
                      <ExternalLink className="w-4 h-4" />
                      View Licence Document
                    </a>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
